export default defineNuxtPlugin((nuxtApp) => {
  const { serverUrl, gfalIdUrl } = useRuntimeConfig().public;
  const userStore = useUserStore();
  const route = useRoute();
  const router = useRouter();
  const { trackEvent } = useGAnalytics();
  const isExpectedCollectibleNotFoundRequest = (
    request: RequestInfo,
    response: any
  ) => {
    const requestPath =
      typeof request === "string"
        ? request
        : typeof (request as { url?: string })?.url === "string"
          ? new URL((request as { url: string }).url, "http://localhost").pathname
          : "";
    return response?.status === 404 && requestPath.startsWith("/api/collectibles/");
  };
  const serverApi = $fetch.create({
    baseURL: serverUrl,
    onRequest({ request, options }) {
      // console.log("server request", request);
    },
    onResponse({ response, options }) {
      // console.log("server response", response._data);
      if (response.status === 401) {
        onNuxtReady(() => {
          trackEvent("user_session_expired");
          if (route.path.includes("user-portal")) {
            const localePath = useLocalePath();
            navigateTo(localePath("/?cause=expired"));
          } else {
            router.push({ query: { cause: "expired" } });
          }
          userStore.logOut();
        });
      }
      if (response.status === 503) {
        onNuxtReady(() => {
          if (route.path !== "/admin") {
            const localePath = useLocalePath();
            navigateTo(localePath("/under-maintenance"));
          }
          userStore.logOut();
        });
      }
    },
    onResponseError({ request, response }) {
      if (isExpectedCollectibleNotFoundRequest(request, response)) {
        console.log(
          response.status,
          "Fetch warning:",
          request,
          "Response:",
          (response as any)._data
        );
        return;
      }
      useLogger().submitLog(
        `${response.status} Fetch error: ${request}`,
        (response as any)._data
      );
    },
  });

  const gfalIdApi = $fetch.create({
    baseURL: gfalIdUrl,
    onRequest({ request, options }) {
      // console.log("gfalId request", request);
    },
    onResponse({ response, options }) {
      // console.log("gfalId response", response._data);
      if (response.status === 401) {
        onNuxtReady(() => {
          trackEvent("user_session_expired");
          if (route.path.includes("user-portal")) {
            const localePath = useLocalePath();
            navigateTo(localePath("/?cause=expired"));
          } else {
            router.push({ query: { cause: "expired" } });
          }
          userStore.logOut();
        });
      }
    },
    onResponseError({ request, response }) {
      if (isExpectedCollectibleNotFoundRequest(request, response)) {
        console.log(
          response.status,
          "Fetch warning:",
          request,
          "Response:",
          (response as any)._data
        );
        return;
      }
      useLogger().submitLog(
        `${response.status} Fetch error: ${request}`,
        (response as any)._data
      );
    },
  });

  return {
    provide: {
      serverApi,
      gfalIdApi,
    },
  };
});
